import React, { useState, Fragment, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './PlantillaConfig.css';

// Material UI Components
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Dropzone from 'react-dropzone';
import { FaCloudUploadAlt, FaFileImage } from 'react-icons/fa';

// Custom Components
import MyButton from '../../../utils/MyButton';

// Icons
import { FaArrowLeft, FaPlus, FaCheck, FaCheckCircle, FaCog } from "react-icons/fa";

// Actions
import {
  clearErrors,
  subirPlantilla,
  getClientes
} from '../../../redux/actions/dataactions';

const PlantillaConfig = ({
  clearErrors,
  subirPlantilla,
  getClientes,
  UI: { loading, errors, aprobado },
  user,
  clienteId
}) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    primaryColor: '#000000',
    secondaryColor: '#000000',
    plantillaType: ''
  });
  const [logo, setLogo] = useState(null);

  const handleOpen = () => {
    setOpen(true);
    clearErrors();
  };

  const handleClose = () => {
    if (aprobado) {
      getClientes();
      setOpen(false);
    }
    setOpen(false);
    clearErrors();
    setFormData({
      primaryColor: '#000000',
      secondaryColor: '#000000',
      plantillaType: ''
    });
    setLogo(null);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!logo || !formData.plantillaType || !formData.primaryColor || !formData.secondaryColor) {
      return;
    }

    const formDataToSubmit = new FormData();
    formDataToSubmit.append('logo', logo);
    formDataToSubmit.append('primaryColor', formData.primaryColor);
    formDataToSubmit.append('secondaryColor', formData.secondaryColor);
    formDataToSubmit.append('plantillaType', formData.plantillaType);

    subirPlantilla(formDataToSubmit, clienteId, user.credentials.handle);
  };



  return (
    <Fragment>
      <MyButton tip="Configurar Plantilla" onClick={handleOpen}>
        <FaCog color="#03178C" className="icon-config" />
      </MyButton>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ color: '#03178C', fontWeight: 'bold' }}>
          {aprobado ? '¡Configuración Exitosa!' : 'Configurar Plantilla'}
        </DialogTitle>

        {aprobado ? (
          <DialogContent>
            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>¡Configuración guardada correctamente!</h2>
            </div>
          </DialogContent>
        ) : (
          <DialogContent>
            <form className="config-form">
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1 }}>
                    Colores Institucionales
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column">
                    <Typography variant="body2" sx={{ mb: 1, color: "text.secondary" }}>Color Primario</Typography>
                    <Box display="flex" alignItems="center" gap={2}>
                      <input
                        type="color"
                        name="primaryColor"
                        value={formData.primaryColor}
                        onChange={handleChange}
                        style={{ width: '50px', height: '40px', padding: 0, border: 'none', cursor: 'pointer' }}
                      />
                      <Typography variant="body2">{formData.primaryColor}</Typography>
                    </Box>
                    {errors?.primaryColor && <Typography color="error" variant="caption">{errors.primaryColor}</Typography>}
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column">
                    <Typography variant="body2" sx={{ mb: 1, color: "text.secondary" }}>Color Secundario</Typography>
                    <Box display="flex" alignItems="center" gap={2}>
                      <input
                        type="color"
                        name="secondaryColor"
                        value={formData.secondaryColor}
                        onChange={handleChange}
                        style={{ width: '50px', height: '40px', padding: 0, border: 'none', cursor: 'pointer' }}
                      />
                      <Typography variant="body2">{formData.secondaryColor}</Typography>
                    </Box>
                    {errors?.secondaryColor && <Typography color="error" variant="caption">{errors.secondaryColor}</Typography>}
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mt: 1, mb: 1 }}>
                    Configuración de Plantilla
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth size="small" error={Boolean(errors?.plantillaType)}>
                    <InputLabel>Tipo de Plantilla</InputLabel>
                    <Select
                      name="plantillaType"
                      value={formData.plantillaType || ''}
                      onChange={handleChange}
                      label="Tipo de Plantilla"
                    >
                      <MenuItem value=""><em>Seleccionar tipo</em></MenuItem>
                      <MenuItem value="prestador">Institucional</MenuItem>
                      <MenuItem value="empresa">Empresarial</MenuItem>
                    </Select>
                    {errors?.plantillaType && <FormHelperText>{errors.plantillaType}</FormHelperText>}
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1 }}>
                    Logo Institucional
                  </Typography>

                  <Dropzone
                    onDrop={(acceptedFiles) => {
                      if (acceptedFiles && acceptedFiles.length > 0) {
                        setLogo(acceptedFiles[0]);
                      }
                    }}
                    accept={{ 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'], 'image/svg+xml': ['.svg'] }}
                    multiple={false}
                    maxSize={5 * 1024 * 1024}
                  >
                    {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                      <Box
                        {...getRootProps()}
                        sx={{
                          border: '2px dashed',
                          borderColor: isDragReject ? 'error.main' : '#03178C',
                          borderRadius: '8px',
                          padding: '30px',
                          textAlign: 'center',
                          cursor: 'pointer',
                          backgroundColor: isDragActive ? '#e0e7ff' : '#f9f9f9',
                          transition: 'background-color 0.3s ease',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <input {...getInputProps()} />

                        {logo ? (
                          <Fragment>
                            <FaFileImage size={40} color="#20B90C" style={{ marginBottom: '10px' }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#03178C' }}>
                              {logo.name}
                            </Typography>
                          </Fragment>
                        ) : (
                          <Fragment>
                            <FaCloudUploadAlt size={50} color="#03178C" style={{ marginBottom: '10px' }} />
                            <Typography variant="body1" color="textSecondary" sx={{ mb: 1 }}>
                              {isDragActive ? "Suelta el logo aquí..." : "Arrastra y suelta el logo o haz clic para subir"}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              Formatos permitidos: PNG, JPG, SVG (Máx. 5MB)
                            </Typography>
                          </Fragment>
                        )}
                      </Box>
                    )}
                  </Dropzone>
                  {errors?.logo && <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{errors.logo}</Typography>}
                </Grid>

                {errors?.general && (
                  <Grid item xs={12}>
                    <Typography color="error" variant="body2" align="center">{errors.general}</Typography>
                  </Grid>
                )}
              </Grid>
            </form>
          </DialogContent>
        )}

        <DialogActions>
          <MyButton tip="Cerrar" onClick={handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
          </MyButton>

          {loading ? (
            <CircularProgress size={30} color="primary" className="progress" />
          ) : (
            aprobado ? (
              <MyButton tip="Continuar" onClick={handleClose}>
                <FaCheckCircle color="#20B90C" className="icon-formulario" />
              </MyButton>
            ) : (
              <MyButton tip="Guardar Configuración" onClick={handleSubmit}>
                <FaPlus color="#03178C" className="icon-formulario" />
              </MyButton>
            )
          )}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

PlantillaConfig.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  subirPlantilla: PropTypes.func.isRequired,
  getClientes: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  UI: state.UI,
  user: state.user
});

export default connect(
  mapStateToProps,
  { clearErrors, subirPlantilla, getClientes }
)(PlantillaConfig);